import { gql } from '@apollo/client';

export const VENDOR_NAMES = gql`
  query getAvailableVendorNames($inputVendorName: String!) {
    getAvailableVendorNames(inputVendorName: $inputVendorName)
  }
`;
